var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"useTime"},[_c('h3',{staticStyle:{"padding":"10px"}},[_vm._v(_vm._s(_vm.lang.pointTime))]),_c('div',{ref:"useTime",staticClass:"echarts-useTime"})])}
var staticRenderFns = []

export { render, staticRenderFns }